const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

// --- Dues Instances API ---

export const fetchDuesDefinitions = async (buildingId, period) => {
  if (!buildingId) {
    throw new Error('Bina ID zorunludur.');
  }
  const params = new URLSearchParams({ buildingId });
  if (period) {
    params.append('period', period);
  }
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-definitions?${params.toString()}`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });
  await handleApiError(response);
  return response.json();
};

export const addDuesDefinition = async (definitionData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-definitions`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(definitionData),
  });
  await handleApiError(response);
  return response.json();
};

export const updateDuesDefinition = async (definitionId, definitionData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-definitions/${definitionId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(definitionData),
  });
  await handleApiError(response);
  return response.json();
};

export const deleteDuesDefinition = async (definitionId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-definitions/${definitionId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });
  await handleApiError(response);
};


// --- Dues Templates API ---

export const fetchDuesTemplates = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-templates`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });
  await handleApiError(response);
  return response.json();
};

export const addDuesTemplate = async (templateData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-templates`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(templateData),
  });
  await handleApiError(response);
  return response.json();
};

export const updateDuesTemplate = async (templateId, templateData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-templates/${templateId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(templateData),
  });
  await handleApiError(response);
  return response.json();
};

export const deleteDuesTemplate = async (templateId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dues-templates/${templateId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });
  await handleApiError(response);
};
